/*
  Manmukh Ayurveda Enterprise Framework
  File: assets/ma-card-save.js
  Purpose: Save/Bookmark toggle for ma-card.liquid (Phase 4, opt-in via
  show_save: true). LocalStorage-backed, non-blocking — never delays
  paint or card interaction, never requires a backend.

  Per the approved Phase 4 spec ("implement the UI visually... hook it
  up using localStorage... ensure it doesn't block page rendering"):
  storage is a single localStorage key holding a JSON array of saved
  card ids — one read/write per click, not per card, so a page with
  many cards costs one small localStorage read on load rather than one
  per card.

  LOADING. Shipped by snippets/ma-card.liquid as a module, and only when a
  card actually renders a save button — not globally. Module scripts are
  de-duplicated by URL, so a page rendering many saveable cards evaluates this
  once. The bound-check inside bind() means a repeat evaluation would be
  harmless regardless.
*/
(function () {
  "use strict";

  var STORAGE_KEY = "ma_saved_cards";
  var SELECTOR = "[data-ma-card-save]";

  function readSaved() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      /* Storage unavailable (private browsing, quota, disabled) — treat
         as "nothing saved" rather than throwing. */
      return [];
    }
  }

  function writeSaved(arr) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
      /* Never throw, never block the click — the button still toggles
         visually for this page view, it just won't persist. */
    }
  }

  function applyState(btn, saved) {
    btn.classList.toggle("is-saved", saved);
    btn.setAttribute("aria-pressed", saved ? "true" : "false");
  }

  function bind(btn) {
    if (btn.dataset.ma3dSaveBound) return;
    btn.dataset.ma3dSaveBound = "true";

    var id = btn.getAttribute("data-save-id");
    if (!id) return;

    applyState(btn, readSaved().indexOf(id) !== -1);

    btn.addEventListener("click", function (e) {
      /* The card itself is very often an <a> (card_url set) — stop this
         button's own click from also triggering that navigation. */
      e.preventDefault();
      e.stopPropagation();

      var list = readSaved();
      var idx = list.indexOf(id);
      var nowSaved;
      if (idx === -1) {
        list.push(id);
        nowSaved = true;
      } else {
        list.splice(idx, 1);
        nowSaved = false;
      }
      writeSaved(list);
      applyState(btn, nowSaved);
    });
  }

  function scan(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var buttons = context.querySelectorAll(SELECTOR);
    for (var i = 0; i < buttons.length; i++) bind(buttons[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { scan(document); });
  } else {
    scan(document);
  }

  /* Theme Editor: newly-added/rearranged blocks bring fresh save
     buttons — existing ones are a no-op thanks to the bound-check. */
  document.addEventListener("shopify:section:load", function (e) {
    scan(e.target);
  });
})();
